<template>
  <el-row class="main-bottom">
    <div class="main-bottom-conts">

 <!-- <el-col class="item-box" :xs="{span:12}" :sm="{span:6}" :md="{span:5}" :lg="{span:2}">
         <div class="title zh">长沙市同迅计算机科技有限公司</div>
        <div class="title en">Tongxun Computer Technology (Changsha) Co. Ltd</div>
      </el-col> -->


      <el-col
        
       style="float: left;
    width: 400px;
    margin-left: 150px;
    margin-top: 25px;"
        
      >
        <div style="font-size: 25px" class="title">长沙市同迅计算机科技有限公司</div>
        <li>
         <a href="#">Tongxun Computer Technology (Changsha) Co. Ltd</a>
        </li>
       
      </el-col>

      <el-col class="item-box" :xs="{span:12}" :sm="{span:6}" :md="{span:5}" :lg="{span:2}">
        <div class="title">关于我们</div>
        
       <li>
          <router-link to="/main/aboutUS"><a href="#">了解神行者</a></router-link>
        </li>
        <li>
          <router-link to="/main/aboutUS"><a href="#">资质与荣誉</a></router-link>
        </li>
        <li>
          <router-link to="/main/aboutUS"><a href="#">联系我们</a></router-link>
        </li>
      </el-col>


      <el-col class="item-box" :xs="{span:12}" :sm="{span:6}" :md="{span:5}" :lg="{span:2}">
        <div class="title">产品中心</div>
         <li>
          <router-link to="/main/fusionGateway"><a href="#">融合网关</a></router-link>
        </li>
         <li>
          <router-link to="/main/smartTV"><a href="#">智慧桌面</a></router-link>
        </li>
        <li>
          <router-link to="/main/SDWAN"><a href="#">SD-WAN</a></router-link>
        </li>
        <li>
          <router-link to="/main/routeDev"><a href="#">路由流控</a></router-link>
        </li>
       
        <li>
          <router-link to="/main/logAudit"><a href="#">日志审计</a></router-link>
        </li>
        <li>
          <router-link to="/main/SDWAN-Client"><a href="#">SD-WAN软终端</a></router-link>
        </li>

      </el-col>
      <el-col class="item-box" :xs="{span:12}" :sm="{span:6}" :md="{span:5}" :lg="{span:2}">
        <div class="title">服务支持</div>
        <li>
          <router-link to="/main/service"><a href="#">技术支持</a></router-link>
        </li>
        <li>
          <router-link to="/main/download"><a href="#">资料下载</a></router-link>
        </li>
        <li>
          <router-link to="/main/service"><a href="#">售后服务</a></router-link>
        </li>
        <li>
          <a href="http://bbs.xspeeder.com/" target="_blank">技术论坛</a>
        </li>
      </el-col>
      <el-col class="item-box" :xs="{span:12}" :sm="{span:6}" :md="{span:5}" :lg="{span:2}">
        <div class="title">合作加盟</div>
        <li>
          <router-link to="/main/cooperative"><a href="#">合作申请</a></router-link>
        </li>
        <li>
          <router-link to="/main/cooperative"><a href="#">渠道政策</a></router-link>
        </li>
        <li>
          <router-link to="/main/cooperative"><a href="#">行业定制</a></router-link>
        </li>
      </el-col>
      <el-col
        class="item-box"
        :xs="{span:24}"
        :sm="{span:15}"
        :md="{span:10,offset:2}"
        :lg="{span:5,offset:0}"
      >
        <div style="color: white;font-size: 30px">400-048-1488</div>
       
        <li>地址：长沙市雨花区 嘉盛·EA财智中心12楼1203号</li>
        <li>周一至周日9:00-18:00</li>
      </el-col>
      <el-col class="item-box code" :xs="{span:24}" :sm="{span:6}" :md="{span:6}" :lg="{span:3}">
        <img :src="require('@/assets/images/WeChaticon.png')" />
        <p class="codetext">扫一扫，关注我们</p>
      </el-col>
    </div>
    <div class="main-bottom-copyright">
      <p>Copyright&copy;2020 hunan. All Rights Reserved.</p>
      <p>长沙市同迅计算机科技有限公司版权所有</p>
      <p>
        <a target="_blank" href="http://beian.miit.gov.cn/">{{ record }}</a>
      </p>
      <p>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43011102001354">湘公网安备 43011102001354号</a>
      </p>
    </div>
  </el-row>
</template>
<script>
  export default {
    data(){
      return{
        record:''
      }
    },
    methods:{
      setRecord(){
        var curWwwPath = window.location.host;
        if(curWwwPath.indexOf('issdn')>-1){
          this.record = '湘ICP备18023659号-1'
        }else if(curWwwPath.indexOf('sxzsdn')>-1){
          this.record = '湘ICP备18023659号-2'
        }else if(curWwwPath.indexOf('sxzwan')>-1){
          this.record = '湘ICP备18023659号-3'
        }else if(curWwwPath.indexOf('xspeeder')>-1){
          this.record = '湘ICP备18023659号-4'
        }else if(curWwwPath.indexOf('dwcache')>-1){
          this.record = '湘ICP备18023659号-5'
        }else if(curWwwPath.indexOf('netsxz')>-1){
          this.record = '湘ICP备18023659号-6'
        }else if(curWwwPath.indexOf('sxzros')>-1){
          this.record = '湘ICP备18023659号-7'
        }else if(curWwwPath.indexOf('i1608')>-1){
          this.record = '湘ICP备18023659号-8'
        }else if(curWwwPath.indexOf('sxzrouter')>-1){
          this.record = '湘ICP备18023659号-9'
        }
      }
    },
    created(){
      this.setRecord();
    }
  }
</script>
<style lang="scss" scoped>
  .main-bottom {
    width: 100%;
  }
  .main-bottom .main-bottom-conts {
    width: 100%;
    background-color: #282828;
    padding: 50px 10px 30px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .main-bottom .main-bottom-conts .item-box {
    margin-bottom: 20px;
    min-height: 176px;
  }
  .main-bottom .main-bottom-conts .title {
    font-size: 16px;
    color: #fff;
    line-height: 1;
    padding-bottom: 16px;
  }
  .main-bottom .main-bottom-conts .title.zh {
    padding-bottom: 12px;
  }
  .main-bottom .main-bottom-conts .title.en {
    font-size: 10px;
  }
  .main-bottom .main-bottom-conts li {
    list-style: none;
    line-height: 1;
    padding-bottom: 12px;
    font-size: 12px;
    color: #b3b3b3;
  }
  .main-bottom .main-bottom-conts li a {
    font-size: 12px;
    color: #b3b3b3;
  }
  .main-bottom .main-bottom-conts li a:hover {
    text-decoration: underline;
    color: #fff;
  }
  .main-bottom .main-bottom-conts .item-box.code {
    text-align: center;
    img{
      width: 115px;
    }
  }
  .main-bottom .main-bottom-conts .codeimg {
    vertical-align: middle;
    width: 115px;
  }
  .main-bottom .main-bottom-conts .codetext {
    font-size: 12px;
    color: #b3b3b3;
    line-height: 30px;
  }
  .main-bottom .main-bottom-copyright {
    width: 100%;
    background-color: #1d1d1d;
    font-size: 12px;
    text-align: center;
    color: #757575;
  }
  .main-bottom .main-bottom-copyright p {
    display: inline-block;
    line-height: 40px;
    margin-right: 12px;
    &:last-child{
      margin-right: 0;
      display: block;
      text-align: center;
      line-height: 1;
      padding-bottom: 12px;
      a{
        display: inline-block;
        padding-left: 24px;
        background: url("../../assets/images/icon-police.png") no-repeat;
        background-size: 20px;
      }
    }
  }
  .main-bottom .main-bottom-copyright p a {
    line-height: 20px;
    color: #757575;
    &:hover{
      color: #ababab;
      text-decoration: underline;
    }
  }
  @media screen and (max-width: 767px) {
    .main-bottom .main-bottom-conts .item-box.code {
      text-align: left;
    }
    .main-bottom .main-bottom-copyright p {
      display: block;
      line-height: 20px;
      margin-right: 0;
    }
  }
</style>
